import { render, staticRenderFns } from "./SocialAuth.vue?vue&type=template&id=496e5a02&scoped=true"
import script from "./SocialAuth.vue?vue&type=script&lang=ts"
export * from "./SocialAuth.vue?vue&type=script&lang=ts"
import style0 from "./SocialAuth.vue?vue&type=style&index=0&id=496e5a02&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.29.7__cache-loader@2.0.1_web_fe5e962fec43a62c82d69a5f09eb460e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496e5a02",
  null
  
)

export default component.exports